import { logger } from "@/utils/logger"
import { TrackPageView } from "./trackPageView.interface"

export const trackPageViewMock: TrackPageView = (page_location, page_title) => {
  logger.debug("[Action:Started] Track Page view", { page_location, page_title })
  return true
}
